module.exports = __webpack_public_path__ + "media/components/country-flag/static/be-99e48c3ed415e1aa2cd125a71b0fdcc9.svg";